import React from 'react';
import { KFLDialog } from '@kamstrup/kamstrup-frontend-library';
import { setRightPanel } from '../../../modules/dialogs/actions';
import DialogHeader from '../../shared/dialog/dialogHeader';
import Translate from '../../shared/localization/localize';
import DialogSection from '../../shared/dialog/dialogSection';
import Tabs from '../../shared/tabs';
import {
  Activity,
  onTabChange,
  activityTabsData,
  TransferActivityTabs,
} from '../../../modules/dialogs/transfer';
import { Historical } from '../../../modules/historical/context';
import * as m from '../../../modules/dialogs/transfer/messages';
import { Activities } from './LogActivity';
import useTxActivities from '../../../modules/dialogs/transfer/useTxActivities';

const TxDialogActivitiesClosed: React.FC = () => {
  const {
    closedTransfers,
    getMoreClosedLogs,
    getLatestClosedLogs,
  } = useTxActivities();
  const content = (
    <>
      <DialogSection>
        <Tabs
          tabs={activityTabsData}
          selectedTab={TransferActivityTabs.CLOSED}
          onChange={onTabChange}
        ></Tabs>
      </DialogSection>
      <DialogSection isMain scrollable>
        <Historical<Activity>
          value={{
            historical: closedTransfers,
            getLatestLogs: getLatestClosedLogs,
            getMoreLogs: getMoreClosedLogs,
          }}
        >
          <Activities />
        </Historical>
      </DialogSection>
    </>
  );

  return (
    <KFLDialog
      header={
        <DialogHeader
          title={<Translate message={m.msgHeaderActivities} />}
          fnCloseDialog={() => setRightPanel('')}
        />
      }
      sections={[content]}
    />
  );
};
export default TxDialogActivitiesClosed;
